import { Directive, effect, ElementRef, inject, input } from '@angular/core';
import { makeTranslateService } from 'src/data/services/common/translate/translate-service-factory';
import { LanguageKey } from 'src/main/translate/language-key/language-key';

@Directive({
  selector: '[appTranslateKey]',
})
export class TranslateKeyDirective {
  key = input<LanguageKey | LanguageKey[] | undefined | null>(null, {
    alias: 'appTranslateKey',
  });
  translateAppendText = input<string | undefined | null>(null);

  private elementRef = inject<ElementRef<HTMLElement>>(ElementRef<HTMLElement>);
  private translateService = makeTranslateService();

  constructor() {
    effect(() => {
      const key = this.key();
      const append = this.translateAppendText();

      if (!this.elementRef || !this.elementRef.nativeElement) return;

      let text = '';

      if (Array.isArray(key)) {
        text = key.map((s) => this.translateService.translateKey(s)).join(' ');
      } else if (key) {
        text = this.translateService.translateKey(key);
      }

      if (append) {
        text += ` ${append}`;
      }

      this.elementRef.nativeElement.textContent = text;
    });
  }
}
